import React, { useState } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import CommonBubble from '@home/components/CommonBubble';
import './index.scss';
import NewMarkIcon from '@home/components/NewMarkIcon';
import { copyContent } from '@gp/utils/utils';

interface IFavoriteProjectProps {
  isHyperlink?: boolean;
  selectedFavProItem?: any;
  setSelectedFavProItem?: (item: any) => void;
  data?: any;
  url?: string;
  showDelete?: boolean;
}

const OnClickBtnItem: React.FC<IFavoriteProjectProps> = (props: any) => {
  const { data, url, showDelete } = props;
  // const [showDelete, setShowDelete] = useState(false);
  const [copyTips, setCopyTips] = useState<any>('Copy Link');

  const handleShare = async () => {
    setCopyTips('Copy successfully!');
    const copyRes = copyContent(url);
    if (copyRes === 1) {
      setCopyTips('Copy successfully!');
    } else {
    }
  };

  return (
    <div
      className="left-nav-text-hd dbg-on-click-btn-item-title-div"
      // onMouseEnter={() => setShowDelete(true)}
      onMouseLeave={() => {
        // setShowDelete(false);
        setCopyTips('Copy Link');
      }}
    >
      <span className={`menu-context-text js-menu-context-text-${data?.id}`}>
        {data.text}
      </span>
      {data?.showNew && (
        <NewMarkIcon
          className={`left-nav-notice ${
            data?.newMarkType === 1 ? 'dbh-beta-tag' : ''
          }`}
          type={data?.newMarkType}
        />
      )}
      {showDelete && (
        <CommonBubble key={data?.project_id} dark content={copyTips}>
          <div
            className="dbg-on-click-btn-item-title-div-link"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              handleShare?.();
            }}
          >
            <SvgIcon type={'share-link'} />
          </div>
        </CommonBubble>
      )}
    </div>
  );
};

export default OnClickBtnItem;
